export default __webpack_public_path__ + "static/media/ic_lesson.12d66763.svg";